var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start mb-5" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "4", lg: "2", xl: "1" } },
                    [
                      _c("back-button", {
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.activateSpinner
                ? _c("spinner")
                : _c("email-group-form", {
                    attrs: { mode: _vm.mode, readonly: !_vm.isEditable },
                    model: {
                      value: _vm.config,
                      callback: function ($$v) {
                        _vm.config = $$v
                      },
                      expression: "config",
                    },
                  }),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "justify-content-end" },
                [
                  _vm.isEditable && _vm.formType !== "add"
                    ? _c(
                        "b-col",
                        { attrs: { cols: "4", lg: "2", xl: "1" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.switchMode("details")
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("common.cncl"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isEditable && _vm.formType !== "add"
                    ? _c(
                        "b-col",
                        { attrs: { cols: "4", lg: "2", xl: "1" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.switchMode("edit")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fa-light fa-pencil" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("administration.edit"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isEditable && _vm.formType !== "add"
                    ? _c(
                        "b-col",
                        { attrs: { cols: "4", lg: "2", xl: "1" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.deleteEmailGroup },
                            },
                            [
                              _c("i", { staticClass: "fa-light fa-trash" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("rights.delete"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEditable && _vm.formType !== "add"
                    ? _c(
                        "b-col",
                        { attrs: { cols: "4", lg: "2", xl: "1" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.editEmailGroup },
                            },
                            [
                              _c("i", { staticClass: "fa-light fa-save" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("common.sve"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mode === "add"
                    ? _c(
                        "b-col",
                        { attrs: { cols: "4", lg: "2", xl: "1" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.addEmailGroup },
                            },
                            [
                              _c("i", { staticClass: "fa-light fa-save" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("common.sve"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }